import { render, staticRenderFns } from "./FinishPage.vue?vue&type=template&id=58300d0f"
import script from "./FinishPage.vue?vue&type=script&lang=js"
export * from "./FinishPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports